<template>
  <ds-section
    secondary
    centered>
    <ds-container size="large">
      <ds-space
        margin-top="large"
        margin-bottom="x-large">
        <ds-logo inverse/>
      </ds-space>
      <ds-space
        margin-bottom="xx-large">
        <ds-button
          size="small"
          path="https://styleguide.cion.visualjerk.de"
          icon="desktop">Styleguide demo</ds-button>&nbsp;
        <ds-button
          size="small"
          path="https://github.com/visualjerk/vue-cion-design-system"
          icon="github">GitHub</ds-button>
      </ds-space>
      <ds-space
        margin-top="x-large"
        margin-bottom="x-large">
        <ds-text size="small">created with ❤️ by visualjerk</ds-text>
      </ds-space>
    </ds-container>
  </ds-section>
</template>

<script>
export default {}
</script>
